"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const simple_react_form_1 = require("simple-react-form");
const schema_1 = require("@orion-js/schema");
class AutoFormForm extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.form = null;
        this.setOnClick = () => {
            const ref = this.props.buttonRef;
            if (ref && ref.current) {
                ref.current.setOnClick(this.submit);
            }
        };
        this.submit = this.submit.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.validate = this.validate.bind(this);
        this.onChange = this.onChange.bind(this);
    }
    componentDidMount() {
        this.setOnClick();
        setTimeout(this.setOnClick, 10);
        setTimeout(this.setOnClick, 100);
    }
    componentWillUnmount() {
        const ref = this.props.buttonRef;
        if (ref && ref.current) {
            ref.current.setOnClick(null);
        }
    }
    submit() {
        return this.submitForm();
    }
    handleError(error, doc) {
        if (error.graphQLErrors) {
            for (const graphQLError of error.graphQLErrors) {
                if (graphQLError.validationErrors) {
                    console.log('Validation errors', graphQLError.validationErrors);
                    this.setState({ validationErrors: graphQLError.validationErrors, doc });
                    this.props.onValidationError(graphQLError.validationErrors);
                }
                else if (graphQLError.error === 'PermissionsError' &&
                    graphQLError.type === 'missingRoles') {
                    const roles = graphQLError.roles;
                    alert(`Client is unauthorized, missing roles: ${roles.join(', ')}`);
                }
                else {
                    console.log(graphQLError);
                    this.props.onError(graphQLError);
                }
            }
        }
        else {
            alert(error.message);
        }
    }
    async onSubmit() {
        const ref = this.props.buttonRef;
        if (ref && ref.current) {
            return ref.current.click();
        }
        else {
            return this.submit();
        }
    }
    async submitForm() {
        const data = this.form.getValue();
        try {
            const errors = await this.validate(data);
            if (errors) {
                return { error: new Error('validationError'), result: null };
            }
            else {
                const cleaned = await this.props.clean(this.props.schema, data);
                const result = await this.props.mutate(cleaned);
                const mutationResult = await this.props.onSuccess(result);
                return { error: null, result: mutationResult };
            }
        }
        catch (error) {
            this.handleError(error, data);
            return { error, result: null };
        }
    }
    async validate(doc) {
        this.setState({ validationErrors: null });
        try {
            const cleaned = await this.props.clean(this.props.schema, doc);
            const validationErrors = (await this.props.validate(this.props.schema, cleaned));
            this.setState({ validationErrors, doc });
            if (validationErrors) {
                console.log('validationErrors:', validationErrors);
                this.props.onValidationError(validationErrors);
            }
            return validationErrors;
        }
        catch (error) {
            console.error('Error validating', error);
        }
    }
    onChange(doc) {
        this.setState({ doc });
        this.props.onChange(doc);
    }
    getErrorMessages() {
        const { validationErrors } = this.state;
        if (!validationErrors)
            return;
        const messages = {};
        for (const key of Object.keys(validationErrors)) {
            const code = validationErrors[key];
            let keySchema = (0, schema_1.dotGetSchema)(this.props.schema, key);
            if (!keySchema)
                continue;
            keySchema = { label: this.props.getDefaultLabel(), ...keySchema };
            const text = this.props.getErrorText(code, keySchema) || code;
            messages[key] = text;
        }
        return messages;
    }
    render() {
        this.props.setRef(this);
        return (react_1.default.createElement(simple_react_form_1.Form, { ref: form => (this.form = form), state: this.props.doc, errorMessages: this.getErrorMessages(), onChange: this.onChange, useFormTag: this.props.useFormTag, onSubmit: this.onSubmit, className: this.props.className }, this.props.children));
    }
}
exports.default = AutoFormForm;
AutoFormForm.defaultProps = {
    onChange: () => { },
    getErrorFieldLabel: key => key,
    useFormTag: true
};
//# sourceMappingURL=index.js.map